import { render } from "./talkCurator.vue?vue&type=template&id=6f7ad808&scoped=true"
import script from "./talkCurator.vue?vue&type=script&lang=js"
export * from "./talkCurator.vue?vue&type=script&lang=js"

import "./talkCurator.vue?vue&type=style&index=0&id=6f7ad808&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f7ad808"]])

export default __exports__